module.exports = __webpack_public_path__ + "img/Hover_MSME.072b7db4.png";